import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import Chip from '@material-ui/core/Chip';

import PropTypes from 'prop-types';

const useStyles = makeStyles(theme => ({
	formControl: {
		margin: theme.spacing(1),
		minWidth: 120,
		maxWidth: 300,
	},
	chips: {
		display: 'flex',
		flexWrap: 'wrap',
	},
	chip: {
		margin: 2,
	},
	noLabel: {
		marginTop: theme.spacing(3),
	},
}));

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
	PaperProps: {
		style: {
			maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
			width: 250,
		},
	},
};

export const BaseMultipleSelectField = props => {
	const { title, name, values, options, handleChange, error } = props;
	const classes = useStyles();
	return (
		<div>
			<InputLabel id='demo-mutiple-chip-label'>{title}</InputLabel>
			<Select
				fullWidth
				multiple
				error={error}
				variant='outlined'
				value={values || []}
				name={name}
				onChange={handleChange}
				input={<Input id='select-multiple-chip' />}
				renderValue={values => (
					<div className={classes.chips}>
						{values.map(value => (
							<Chip key={value} label={value} className={classes.chip} />
						))}
					</div>
				)}
				MenuProps={MenuProps}
			>
				{options.map(option => (
					<MenuItem key={option.value} value={option.label}>
						{option.label}
					</MenuItem>
				))}
			</Select>
		</div>
	);
};

BaseMultipleSelectField.propType = {
	title: PropTypes.string.isRequired,
	options: PropTypes.array.isRequired,
	handleChange: PropTypes.func.isRequired,
	values: PropTypes.array.isRequired,
	error: PropTypes.bool,
};

export default BaseMultipleSelectField;
